import { makeStyles } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import usePermissionsCheck from "../../hooks/usePermissionCheck";
const useStyles = makeStyles((theme) => ({
    root: {},
    section: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(1),
        "& > svg": {
            marginRight: theme.spacing(1),
        },
    },
    item: {
        paddingLeft: 20,
        "&.Mui-selected": {
            borderRight: `3px solid ${theme.palette.primary.dark}`,
        },
    },
    title: {
        fontWeight: "bold",
    },
}));
const PermissionCheckWrapper = ({ children, permissions, groupIds, }) => {
    const { hasRequiredPermissions } = usePermissionsCheck({
        permissions,
        groupIds,
    });
    return permissions
        ? children({ hasRequiredPermissions })
        : children({ hasRequiredPermissions: true });
};
export default function NavBarSection({ title, icon, items, groupIds }) {
    const classes = useStyles();
    const { pathname } = useLocation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.section },
            icon,
            React.createElement(Typography, { className: classes.title }, title)),
        items.map(({ path, key, name, minimumPermission, external = false }) => (React.createElement(PermissionCheckWrapper, { key: key, permissions: minimumPermission, groupIds: groupIds }, ({ hasRequiredPermissions }) => external ? (React.createElement(Link, { href: hasRequiredPermissions ? path : undefined, underline: "none", target: "_blank" },
            React.createElement(ListItem, { className: classes.item, "data-cy": key, selected: pathname.endsWith(path), button: true, disabled: !hasRequiredPermissions },
                React.createElement(ListItemText, { primary: name })))) : (React.createElement(ListItem, { className: classes.item, "data-cy": key, component: RouterLink, to: path, selected: pathname.endsWith(path), button: true, disabled: !hasRequiredPermissions },
            React.createElement(ListItemText, { primary: name }))))))));
}
//# sourceMappingURL=index.js.map